export const NAV_BAR_CONTEXT = 'navBar';
